import script from "./PieChart.vue?vue&type=script&lang=ts"
export * from "./PieChart.vue?vue&type=script&lang=ts"

import "./pie-chart.scss?vue&type=style&index=0&lang=scss"

const __exports__ = script;

export default __exports__